import { useBunja } from 'bunja/react';
import { isSameDay } from 'date-fns';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { Datetime } from '@flipster/react/design-utils/datetime';
import Formatted from '@flipster/react/design-utils/formatted';
import { css } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';
import { startOfUTCDay, timestampToDate } from '@flipster/utils/datetime';

import { contentfulImageUrl } from '../../../../contentful/assets';
import { DailyCheckInButton } from '../../component/tc-button';
import { competitionEventsBunja } from '../../state';
import { EventTitle } from '../event-title';
import { Rules } from '../rules';
import { NoticeBanner } from './notice-banner';
import { dailyCheckInBunja } from './state';

export const DailyCheckInContent = () => {
  return (
    <>
      <EventTitle />
      <DailyCheckIn />
      <Rules />
    </>
  );
};

export const DailyCheckIn = () => {
  const { selectedEventTabAtom } = useBunja(competitionEventsBunja);
  const { dailyCheckInHistoryAtom, dailyCheckInListAtom, dailyCheckInSuccessAtom } = useBunja(dailyCheckInBunja);
  const selectedEventTab = useAtomValue(selectedEventTabAtom);
  const dailyCheckInHistory = useAtomValue(dailyCheckInHistoryAtom);
  const dailyCheckInList = useAtomValue(dailyCheckInListAtom);
  const dailyCheckInSuccess = useAtomValue(dailyCheckInSuccessAtom);

  return (
    <section
      className={vstack({
        gap: 64,
        py: 40,
        px: 24,
        borderColor: 'border.default.level-2',
        borderWidth: '1px',
        borderStyle: 'solid',
        rounded: 16,
      })}
    >
      <div className={vstack({ w: '100%', gap: 20, px: { tablet: 16 } })}>
        <p className={css({ textStyle: 'Title/M' })}>
          <FormattedMessage
            id='Competition.r251217.Days_checked_in_colon_count'
            values={{
              count: <Formatted.Number value={dailyCheckInSuccess.successCount} css={{ color: 'var(--key-color)' }} />,
            }}
          />
        </p>
        <NoticeBanner />
      </div>
      <ul
        className={css({
          display: 'grid',
          gridTemplateColumns: {
            base: 'repeat(auto-fit, minmax(112px, 1fr))',
            tablet: 'repeat(auto-fit, minmax(156px, 1fr))',
          },
          width: '100%',
          columnGap: { base: 12, tablet: 40 },
          rowGap: 24,
        })}
      >
        {dailyCheckInList.map((date) => (
          <li key={date.toString()} className={vstack({ gap: 12 })}>
            <img
              src={
                dailyCheckInHistory.find((h) => isSameDay(startOfUTCDay(timestampToDate(h.checkedInAt)), date))
                  ? contentfulImageUrl(selectedEventTab?.dailyCheckInIcon?.url ?? '')
                  : contentfulImageUrl(selectedEventTab?.dailyCheckInUnfilledIcon?.url ?? '')
              }
              alt='gift'
              height={112}
            />
            <Datetime value={date} format='MMM dd' />
          </li>
        ))}
      </ul>
      <DailyCheckInButton buttonLocation='daily_check_in' />
    </section>
  );
};
